import { useQuery } from '@tanstack/react-query';
import { useAppStore } from 'Store';
import { fetchImportStatus } from '../utils/polling';

const QUERY_KEY = ['ImportStatusData'];

export const useFileImportStatus = () => {
    const { isSidePanelOpen, setPollingData } = useAppStore();
    return useQuery<ListImportExportApiResponse, Error>({
        queryKey: QUERY_KEY,
        queryFn: () => fetchImportStatus(),
        enabled: isSidePanelOpen,
        staleTime: 0,
        onSuccess: (fetchedData) => {
            setPollingData(fetchedData.inProgress, fetchedData.completed);
        }
    });
};
